import { render, staticRenderFns } from "./Template3.vue?vue&type=template&id=179143be&scoped=true&"
import script from "./Template3.vue?vue&type=script&lang=js&"
export * from "./Template3.vue?vue&type=script&lang=js&"
import style0 from "./Template3.vue?vue&type=style&index=0&id=179143be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179143be",
  null
  
)

export default component.exports